module.exports = __webpack_public_path__ + "img/ic_share_tel.3cdb2571.svg";